import axios from '../assets/axios'
import AuthAxios from 'axios'
import { setKey, getKey } from '../assets/utils'
import { jsBridge, hasNativeMethod } from '../assets/jsBridge'
 

// 检查用户信息完整性
function checkUserInfo (userInfo) {
  const keys = ['mobile', 'token', 'wu']
  if (typeof userInfo !== 'object' || userInfo === null) return false
  for (let i in keys) {
    if (!userInfo.hasOwnProperty(keys[i]) || userInfo[keys[i]] === null) return false
  }
  return true
}

export default {
  namespaced: true,

  state: {
    // 用户信息
    userInfo: {
      userId: '', // 用户ID
      mobile: '', // 手机号
      idCard: '', // 身份证
      token: '', // token
      time: '', // 更新时间
      name: '', // 用户名
      authStatus: [], // 身份信息状态
      wu: false // IOS黑名单
    },
    guessLikeVisible: 'N', // 猜你喜欢
    rightsCenterVisible: 'N', // 权益中心
    fundPageVisible: 'N', // 发现页

    couponPacksVisible: 'N', // 优惠券
    threeRepayVisible: 'N', // 三方还款
    welfareCenterVisible: 'N', // 福利中心
    messageCenterVisible: 'N', // 消息中心
    feedbackVisible: 'N', // 反馈评价
    monitor: 'Y', 
    // 额度信息
    quotaInfo: {
      relationId: '',
      creditLimit: '',
      creditStatus: '',
      exTxnSeq: '',
      failureTime: '',
      loanList: '',
      lockingDay: '',
      productCharacteristics: '',
      totalLimit: '',
      loanStatus: '',
      svipMark: '',
      overdueAmount: ''
    }
  },

  mutations: {
    // 设置用户信息
    setUserInfo (state, data) {
      const { mobile, userId } = data

      // 针对神策全局注册手机号和uid
      const isSetKey = sessionStorage.getItem('isSetKey')

      if (!isSetKey && window.$sensors && userId) {
        window.$sensors.registerPage({
          phone_number: mobile,
          custId: userId
        })
        window.$sensors.login(userId)
        sessionStorage.setItem('isSetKey', 'Y')
      }


      setKey('userInfo', Object.assign(data, { time: Date.now() }))
      Object.keys(data).forEach(key => {
        state.userInfo[key] = data[key]
      })
    },

    setEntrance (state, data) {
      const { guessLike, rightsCenter, couponPacks, fundPage, threeRepay, welfareCenter, msgCenter, feedback } = data
      state.guessLikeVisible = guessLike || 'Y'
      state.rightsCenterVisible = rightsCenter || 'Y'
      state.couponPacksVisible = couponPacks || 'Y'
      state.fundPageVisible = fundPage || 'Y'
      state.threeRepayVisible = threeRepay || 'Y'
      state.welfareCenterVisible = welfareCenter || 'Y'
      state.messageCenterVisible = msgCenter || 'Y'
      state.feedbackVisible = feedback || 'N'
    },
    setmonitor (state, data) {
      state.monitor = data.monitorAcc
    },

    // 设置额度信息
    setLimitInfo (state, data) {
      Object.keys(data).forEach(key => {
        state.quotaInfo[key] = data[key]
      })
      if (state.quotaInfo.creditStatus === 'LOAN_INFO') {
        state.quotaInfo.loanStatus = state.quotaInfo.loanList[0] && state.quotaInfo.loanList[0].loanStatus
      } else {
        state.quotaInfo.loanStatus = state.quotaInfo.creditStatus
      }
    }
  },

  actions: {
    // 获取用户信息 forceUpdate 强制更新用户信息，一般情况下并不推荐
    async getUserInfoX ({ commit }, { forceUpdate = false, checkToken = false, queryType = 'simple' } = {}) {
      let userInfo = getKey('userInfo')
      if (checkUserInfo(userInfo) && !forceUpdate) {
        commit('setUserInfo', userInfo)
        return userInfo
      }
      if (checkToken && (userInfo && !userInfo.token)) return userInfo
      const response = await axios.get('/user/v1/userBaseInfo', { params: { queryType, ts: Date.now() } })
      if (response && response.data.success) {
        const responseData = response.data.data
        Object.keys(responseData).forEach(key => {
          userInfo[key] = responseData[key]
        })
        commit('setUserInfo', userInfo)
      }
      return userInfo
    },

    // 获取短信验证码
    async sendCodeX ({ commit }, params) {
      const response = await axios.post('/user/v1/loginGetSms', params)
      return response.data
    },

    // 验证码登录
    async loginBySmsX ({ commit }, params) {
      const response = await axios.post('/user/v1/loginBySms', params)
      if (response.data.success) {
        if (hasNativeMethod('login')) {
          jsBridge('login', response.data.data)
        }
        commit('setUserInfo', response.data.data)
      }
      return response.data
    },

    // 退出登录
    async logoutX ({ commit }, params) {
      const response = await axios.get('/user/v1/logout', params)
      return response.data
    },

    // 获取用户额度
    async getLimitX ({ commit }, params) {
      try {
        const response = await axios.post('/index/v1/credit-limit', params)
        if (response.data.success) {
          commit('setLimitInfo', response.data.data)
        } else {
          commit('setLimitInfo', {
            creditStatus: 'SERVER_OFF_LINE'
          })
        }
        return response.data
      } catch (exp) {
        commit('setLimitInfo', {
          creditStatus: 'SERVER_OFF_LINE'
        })
      }
    },

    async fetchTokenX ({ commit }, params) {
      const response = await axios.post('/union/swapLoginKey', params)
      return response.data
    },

    // 提交设备信息
    async submitDeviceInfoX ({ commit }, params) {
      const response = await axios.post('/pushdata/device-info', params, { notNeedBaseURL: true })
      return response.data
    },
    // 三方跳转授权
    async getPermissions ({ commit }, params) {
      const response = await AuthAxios.post('/api/auth/v2/merchant-auth', params)
      return response.data
    },
    // 微博三方跳转授权
    async getWeiboPermissions ({ commit }, params) {
      const response = await axios.post('/auth/v2/merchant-auth-common', params)
      return response.data
    },
    // 获取福利信息
    async getBenefitsX ({ commit }, params) {
      const response = await axios.post('/welfare/v1/queryAchievement', params)
      return response.data
    },
    // 获取我的成就
    async queryAchievementX ({ commit }, params) {
      const response = await axios.post('/welfare/v1/queryWelfare', params)
      return response.data
    },
    // IRR24激活接口调用
    async getIRR24 ({ commit }, params) {
      let userInfo = getKey('userInfo')
      let IRR24 = getKey('IRR24')
      if (IRR24) {
        return IRR24
      } else if (checkUserInfo(userInfo)) {
        const response = await axios.post('/index/v1/after-login', { params: { productCode: 'TMDP', trafficCode: getKey('channel'), channelNo: getKey('channel') } })
        if (response.data.success) {
          localStorage.setItem('IRR24', JSON.stringify(response.data.data))
        }
        return response.data
      } else {
        return false
      }
    },
    // 获取小美图片展示
    async queryXiaomeiIconX ({ commit }, params) {
      const response = await axios.post('/user/v1/my', params)
      return response.data
    },
    // 获取用户状态
    async getUserStatus ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/jumpToLoanMarket', params)
      return response.data
    },
    // 获取导流数据列表
    async getBorrowList ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/query', params)
      return response.data
    },
    // 获取导流产品详情
    async getBorrowDetail ({ commit }, params) {
      const repsonse = await axios.post('/loan-market/v1/detail', params)
      return repsonse.data
    },
    // 联登接口
    async exLogin ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/ex-login', params)
      return response.data
    },
    // 导流弹窗接口
    async getBorrowPopX ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/popup', params)
      return response.data
    },
    // 导流弹窗跳转后端埋点
    async getBorrowPopJumpX ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/clickPopup', params)
      return response.data
    },
    // 获取渠道跳转开关
    async getChannelJumpX ({ commit }, params) {
      const response = await axios.post('/loan-market/v2/channelJump', params)
      return response.data
    },
    // 获取老带新落地页配置，如登录后的跳转逻辑，安卓都同意下载
    async getActivityOWN ({ commit }, params) {
      const response = await axios.post('/activity/old-with-new/v1/landingConfig', params)
      return response.data
    },
    // 查询VIP相关展示状态
    async showStatusX ({ commit }, params) {
      const response = await axios.post('/show/v1/query', params)
      return response.data
    },
    // 获取导流主页已申请产品
    async getApplyList ({ commit }, params) {
      const response = await axios.post('/loan-market/apply-list', params)
      return response.data
    },
    // 获取是否弹窗
    async queryPopupX ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/channelReturn', params)
      return response.data
    },
    // 获取是否弹窗
    async queryConfigListX ({ commit }, params) {
      const response = await axios.get('/loan-market/api-config-list', params)
      return response.data
    },
    async apiListBannerX ({ commit }, params) {
      const response = await axios.post('/loan-market/api-banner', params)
      return response.data
    },
    // api申请列表
    async apiApplyListX ({ commit }, params) {
      const response = await axios.post('/loan-market/api-apply-list', params)
      return response.data
    },
    // OCR页面打标接口
    async ocrAddTag ({ commit }, params) {
      const response = await axios.post('/diversion/v1/ocr-add-tag', params)
      return response
    },
    // api申请列表
    async diversionInfo ({ commit }, params) {
      const response = await axios.get('/diversion/v1/info', params)
      return response.data
    },
    // 广告
    async adBanner ({ commit }, params) {
      const response = await axios.get('/index/v1/get-risk-banner', { params })
      return response.data
    },
    // 导流点击记录
    async addEvent ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/add-event', params)
      return response.data
    },
    // 分流联登
    async distributeUnionLogin ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/distUnionLogin', params)
      return response.data
    },
    // 获取api产品跳转链接
    async getApiProductUrl ({ commit }, params) {
      const response = await axios.get('/diversion/v1/jump-url', { params })
      return response.data
    },
    // 是否强弹协议
    async protocolShow ({ commit }, params) {
      const response = await axios.post('/diversion/v1/force/protocol/show', params)
      return response.data
    },
    // 发现页跳转路由
    async fundPageRoute ({ commit }, params) {
      const response = await axios.get('/index/v1/fundPageRoute', { params })
      return response.data
    },
    // 新人活动V2详情
    async newPersonActive ({ commit }, params) {
      const response = await axios.post('/welfare/v1/new-person-detail', { params })
      return response.data
    },
    // 新人活动V2详情
    async couponStatus ({ commit }, params) {
      const response = await axios.post('/welfare/v1/new-person-coupon', { params })
      return response.data
    },
    // 新人活动动画点击记录
    async clickNewPerson ({ commit }, params) {
      const response = await axios.post('/welfare/v1/click-new-person', { params })
      return response.data
    },
    async getPrivilegeCardInfo ({ commit }, params) {
      const response = await axios.post('/privilege/v1/outline-list', params)
      return response.data
    },
    async getFloatViewInfo ({ commit }, params) {
      const response = await axios.post('/index/v1/floatView', params)
      return response.data
    },
    /**
     * 获取用户业务标签
     * passCardTag：HAVE_QUALIFICATION:有pass卡资格,HAVE_EFFECTIVE_LIMIT:有有效未使用额度PASS卡额度,为空表示没有相关逻辑
     */
    async getBizTag ({ commit }, params) {
      const response = await axios.post('/index/v1/bizTag', params)
      return response.data
    },

    async getPassCardProcessStatus ({ commit }, params) {
      const response = await axios.post('/pass/v1/passProcessStatus')
      return response.data
    },
    async csShowStyle ({ commit }, params) {
      const response = await axios.post('/index/v1/csShowStyle')
      return response.data
    },
    async getPassIndexCard ({ commit }, params) {
      const response = await axios.post('/pass/v1/indexCard', params)
      return response.data
    },
    /**
     * 获取公共验证码
     * @param {smsType} USER_INFO_CHANGE: 修改用户信息；USER_INFO_CANCEL: 注销用户
     * @returns smsKey
     */
    async getCommonSmsCode ({ commit }, params) {
      const response = await axios.post('/sms/v1/common-smsCode', params)
      return response.data
    },
    /**
     * 用户注销判断
     * @returns canCancel 是否能注销； reason 不能注销的原因
     */
    async getCanCancelStatus ({ commit }, params) {
      const response = await axios.post('/user-cancel/v1/canCancel', params)
      return response.data
    },
    /**
     *
     * @param {smsKey} 验证码key
     * @param {smsCode*} 验证码
     * @returns result： Y:成功；N:失败
     */
    async cancelConfirm ({ commit }, params) {
      const response = await axios.post('/user-cancel/v1/confirm', params)
      return response.data
    },
    /**
     *
     * @param {smsKey} 验证码key
     * @param {smsCode*} 验证码
     * @returns result： Y:成功；N:失败
     */
    async agreementUpdateX ({ commit }, params) {
      const response = await axios.post('/app/v1/agreement', params)
      return response.data
    },

    async mineConfigX ({ commit }, params) {
      const response = await axios.post('/show/v1/entrance', params)
      commit('setEntrance', response.data?.data?.entranceConfig) 
      return response.data
    },
    async monitorX ({ commit }, params) {
      const response = await axios.post('/show/v1/monitor', params)
      commit('setmonitor', response.data?.data)
      return response.data
    },
    async customerFeedback ({ commit }, params) {
      const response = await axios.post('/user/v1/customer/feedback', params)
      return response.data
    },
    async feedbackEvaluate ({ commit }, params) {
      const response = await axios.post('/user/v1/feedback', params)
      return response.data
    }
  }
}